import React from 'react';
import PlaybookTransformationOutput from 'app/shared/components/testing-suite/PlaybookTransformationOutput';
import { useTestPipelineDrawerContext } from 'app/pipeline-details/StatusItem/TestPipelineDrawerContextProvider';

export default function IntegrationOutputTab() {
  const {
    state: {
      chainState: { integrationOutput },
    },
  } = useTestPipelineDrawerContext();

  const { loading, error, outputEvent, errors } = integrationOutput;

  if (error) {
    return null;
  }

  let props = {
    loading,
    trackingEventName: 'test_pipeline_integration_output_viewed',
  };

  if (!loading) {
    props = {
      ...props,
      outputEvent,
      outputErrors: errors,
    };
  }

  return <PlaybookTransformationOutput {...props} />;
}
